import { render, staticRenderFns } from "./FutureServicesDialog.vue?vue&type=template&id=36f96a8e&scoped=true&"
import script from "./FutureServicesDialog.vue?vue&type=script&lang=js&"
export * from "./FutureServicesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f96a8e",
  null
  
)

export default component.exports